import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ReferralPage from "@/pages/ReferralPage";
import Dashboard from "@/pages/admin/Dashboard";
import Talents from "@/pages/admin/Talents";
import Sales from "@/pages/admin/Sales";
import Disbursements from "@/pages/admin/Disbursements";
import RevenueModel from "@/pages/admin/RevenueModel";
import Reports from "@/pages/admin/Reports";
import TalentPortal from "@/pages/talent/Portal";

function LoadingScreen() {
  return (
    <div className="min-h-screen grid place-items-center">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground">Memuat...</p>
      </div>
    </div>
  );
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "admin") return <Navigate to="/portal" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function TalentRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function LoginRoute({ portal }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LoadingScreen />;
  if (user) return <Navigate to={user.role === "admin" ? "/dashboard" : "/portal"} replace />;
  return <Login key={portal} portal={portal} />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<LoginRoute portal="talent" />} />
            <Route path="/admin/login" element={<LoginRoute portal="admin" />} />
            <Route path="/ref/:code" element={<ReferralPage />} />
            <Route path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="/talents" element={<AdminRoute><Talents /></AdminRoute>} />
            <Route path="/sales" element={<AdminRoute><Sales /></AdminRoute>} />
            <Route path="/disbursements" element={<AdminRoute><Disbursements /></AdminRoute>} />
            <Route path="/revenue-model" element={<AdminRoute><RevenueModel /></AdminRoute>} />
            <Route path="/reports" element={<AdminRoute><Reports /></AdminRoute>} />
            <Route path="/portal" element={<TalentRoute><TalentPortal /></TalentRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
            {/* landing is public home */}
          </Routes>
          <Toaster position="top-right" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
